import React, { useState } from 'react'
import Grid from '@mui/material/Grid2';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import "./jobboard.css"
import * as XLSX from 'xlsx';
import { faCircleCheck, faFileLines } from '@fortawesome/free-regular-svg-icons';
import { Modal } from 'react-bootstrap';
import csvFile from '../../assets/Sample_forms/Job-scrapper-form.csv';
import { apiService } from '../../services/apiService';
import { toast } from 'react-toastify';
function JobBulkUpload() {
    const navigate = useNavigate();
    const [file, setFile] = useState(null);
    const [fileName, setFileName] = useState('');
    const [error, setError] = useState('');
    const [errorapi, setErrorapi] = useState([]);
    const [importbtnshow, setImport] = useState(false);
    const [loading, setLoading] = useState(false);
    const [show_modal, setShowmodal] = useState(false);
    const [data, setData] = useState([]);
    const [previewReady, setPreviewReady] = useState(false);
    const [submitloader, setSubmitloader] = useState(false);

    const validTypes = [
        'text/csv',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    ];
    const handleClose = () => {
        setShowmodal(false);
        navigate("/job-board")
    };
    const handleFile = (selectedFile) => {
        if (!selectedFile) return;

        if (!validTypes.includes(selectedFile.type)) {
        setError('Only CSV or Excel files are allowed.');
        setFile(null);
        setFileName('');
        setData([]);
        setPreviewReady(false);
        return;
        }

        setError('');
        setFile(selectedFile);
        setFileName(selectedFile.name);
        setData([]);
        setPreviewReady(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        const droppedFile = e.dataTransfer.files[0];
        handleFile(droppedFile);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleInputChange = (e) => {
        const selected = e.target.files[0];
        handleFile(selected);
    };

    const handleValidate = async () => {
        if (!file) {
            setError('Please upload a file.');
            return;
        }

        setLoading(true);
        setError('');
        setErrorapi('');

        const formDataObj = new FormData();
        formDataObj.append('file', file);

        const reader = new FileReader();

        reader.onload = async (e) => {
            try {
                const arrayBuffer = new Uint8Array(e.target.result);
                const workbook = XLSX.read(arrayBuffer, { type: 'array' });
                const worksheet = workbook.Sheets[workbook.SheetNames[0]];
                const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

                setData(jsonData);
                setPreviewReady(true);

                // Now make the API request
                const response = await apiService.postRequest('/job-posts/validate-file', formDataObj, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });

                if (response && response.success === true) {
                    setErrorapi('');
                    setImport(true);
                } else {
                    setImport(false);
                    if (response.errors) {
                        setErrorapi(response.errors);
                    }
                    if (response.authenticate === false) {
                        await apiService.postRequest('/auth/logout');
                        localStorage.clear();
                        sessionStorage.clear();
                        window.location.href = '/login';
                    }
                }
            } catch (err) {
                console.error(err);
                setError('Failed to parse file.');
                setPreviewReady(false);
            } finally {
                setLoading(false);
            }
        };

        reader.onerror = () => {
            setError('File reading failed.');
            setLoading(false);
        };

        reader.readAsArrayBuffer(file);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        // Reset errors
        // setErrors({});
        setSubmitloader(true);
        const formDataObj = new FormData();
        formDataObj.append('file', file);
        try {
            const response = await apiService.postRequest('/job-posts/import', formDataObj, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            if (response && response.success === true) {
                setErrorapi("");
                setShowmodal(true);
                toast(response.message);
            }else{
                // setErrorMessage(response.message);
                if (response.errors) {
                    setErrorapi(response.errors);
                }
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        }catch (error){
            console.log("Error",error)
        }finally{
            setSubmitloader(false);
        }
    }

    const cancelSecond = () => {
        setFile(null);
        setFileName('');
        setData([]);
        setPreviewReady(false);
        setImport(false);
        setErrorapi([]);
    }
    const handleDownloadCsv = () => {
    fetch(csvFile)
        .then((response) => response.blob())
        .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'sample_jobs_file.csv';
        a.click();
        window.URL.revokeObjectURL(url);
        });
    };

  return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{sm:12}} container className="main_jobseeker">
                <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead">
                    <h3>Job Board</h3>
                    <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> <b onClick={()=>navigate("/job-board")}>Job Board</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> Bulk Import</span>
                    <h4 className='mt-4 mb-4' style={{color: "#C42B7D",fontWeight: "600"}}>Bulk Import</h4>
                </Grid>
                <Grid size={{xs:12}} container alignItems="center" justifyContent="flex-end" className="gap-3">
                    <span>Download the skeleton file and fill it with proper data</span>
                    <button onClick={handleDownloadCsv} className='registersendbtn2'>Download CSV</button>
                </Grid>
                <Grid size={{md:12,xs:12}} container flexDirection="column">
                    {!previewReady ? (<>
                    <p style={{fontWeight:"500",marginBottom:"10px"}}>Please upload CSV File before validation</p>
                    <label
                        htmlFor="fileInput"
                        onDrop={handleDrop}
                        onDragOver={handleDragOver}
                        style={{
                            display: 'block',
                            border: '2px dashed #888',
                            borderRadius: 3,
                            padding: 40,
                            textAlign: 'center',
                            cursor: 'pointer',
                            backgroundColor: '#f9f9f9',
                        }}
                    >
                        <FontAwesomeIcon className='file_uploadericon' icon={faFileLines} />
                        {fileName && !error ? (
                            <h5 style={{ marginTop: 0 }}>Preview: {fileName}</h5>
                        ):
                        <p className='mb-0'>Drag and drop a CSV or Excel file here, or click to select</p>
                        }
                        <input
                            id="fileInput"
                            type="file"
                            accept=".csv, .xls, .xlsx"
                            onChange={handleInputChange}
                            style={{ display: 'none' }}
                        />
                    </label>

                    {error && <p style={{ color: 'red', marginTop: 10 }}>{error}</p>}

                    <Grid size={{md:12,xs:12}} container justifyContent="flex-end" className="gap-5">
                        <button className='registersendbtn1' onClick={cancelSecond}>Cancel</button>
                        <button className='registersendbtn2' onClick={handleValidate} disabled={loading}>Validate</button>
                    </Grid>
                    </>) : previewReady && data.length > 0 ? <>
                        <Grid size={{xs:12}} container style={{overflow:"auto",maxHeight:"500px"}}>
                            {fileName && !error && (
                                <h5 style={{ marginTop: 20,width:"100%" }}>Preview: {fileName}</h5>
                            )}
                            <Grid size={{xs:12}}>
                                <table className="table-auto border mt-4">
                                    <thead>
                                        <tr>
                                            {data[0].map((col, idx) => (
                                                <th key={idx} className="border px-2 py-1 bg-gray-200">
                                                {col}
                                                </th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.slice(1).map((row, idx) => (
                                            <tr key={idx}>
                                                {row.map((cell, i) => (
                                                <td key={i} className="border px-2 py-1">
                                                    {cell}
                                                </td>
                                                ))}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </Grid> 
                        </Grid>
                        {errorapi.length > 0 && (
                        <Grid size={{md:10,xs:12}} container flexDirection="column" className="p-3 yellow_attbox">
                            <p style={{color:"red"}}>Attention</p>
                            {errorapi.map((err, index) => (
                                <span key={index}>{err}</span>
                            ))}
                        </Grid>
                        )}
                        <Grid size={{md:12,xs:12}} container justifyContent="flex-end" className="gap-5">
                            <button className='registersendbtn1' onClick={cancelSecond}>Cancel</button>
                            {importbtnshow &&
                                <button className='registersendbtn2' onClick={handleSubmit}>{submitloader ? <img src={require('../../assets/whiteloader.gif')} alt=''/> : 'Import'}</button>
                            }
                        </Grid>
                        </>
                    :""}
                </Grid>
            </Grid>
            <Modal centered show={loading}>
                <Modal.Body>
                    <div className='d-flex flex-column align-items-center'>
                        <img style={{width:"100px"}} src={require("../../assets/pinkloader.gif")} alt="loader"/>
                        <h4 className='text-center'>Please wait</h4>
                        <small className='text-center'>Please wait while we process and load your document preview. This may take a few seconds.</small>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal centered show={show_modal} onHide={handleClose}>
                <Modal.Header closeButton style={{border:"none"}}>
                    
                </Modal.Header>
                <Modal.Body>
                    <div className='d-flex w-100 text-center flex-column align-items-center modal_register'>
                        <FontAwesomeIcon className='main_tickiconpopup' icon={faCircleCheck} />
                        <h3>Successfully Import</h3>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    </div>
  )
}

export default JobBulkUpload
